import { lazyWithReload } from "utils/lazy-loader";
import { Navigate } from "react-router-dom";
import RedirectToBooking from "pages/static/RedirectToBooking";

const RedirectingToLogin = lazyWithReload(() =>
  import("pages/static/RedirectingToLogin")
);
const City = lazyWithReload(() => import("pages/city/City"));
const Property = lazyWithReload(() => import("pages/property/Property"));
const Agents = lazyWithReload(() => import("pages/static/Agents"));
const BlogListing = lazyWithReload(() => import("pages/static/BlogListing"));
const ContactUs = lazyWithReload(() => import("pages/static/ContactUs"));
const DowningRebook = lazyWithReload(() =>
  import("pages/static/DowningRebook")
);
const Faqs = lazyWithReload(() => import("pages/static/Faqs"));
const Friend = lazyWithReload(() => import("pages/static/Friend"));
// const GroupBooking = lazyWithReload(() => import("pages/static/GroupBooking"));
const Offers = lazyWithReload(() => import("pages/static/Offers"));
const Parent = lazyWithReload(() => import("pages/static/Parent"));
const RoomType = lazyWithReload(() => import("pages/room-type/RoomType"));
const SquareGardens = lazyWithReload(() =>
  import("pages/static/SquareGardens")
);
const StudentLifeAtDowning = lazyWithReload(() =>
  import("pages/static/StudentLifeAtDowning")
);
const Support = lazyWithReload(() => import("pages/static/Support"));
const CityListing = lazyWithReload(() => import("pages/static/CityListing"));
const FindYourRoom = lazyWithReload(() => import("pages/static/FindYourRoom"));
const Compare = lazyWithReload(() => import("pages/comparison/ComparionPage"));
const ViewwingDetail = lazyWithReload(() =>
  import("pages/viewing-detail/ViewingDetail")
);
const BookAViewing = lazyWithReload(() => import("pages/book-a-viewing"));
const PolicyLegal = lazyWithReload(() => import("pages/legal/PolicyLegal"));
const Favourite = lazyWithReload(() => import("pages/favourites/Favourite"));
const UniverSitypage = lazyWithReload(() =>
  import("pages/university/UniverSitypage")
);
const Wellness = lazyWithReload(() => import("pages/wellness/Wellnes"));
const BlogDetailPage = lazyWithReload(() => import("pages/static/BlogDetail"));
const PolicyLegalCookie = lazyWithReload(() =>
  import("pages/legal-cookie/PolicyLegalCookie")
);
const PolicyLegalTerms = lazyWithReload(() =>
  import("pages/legal-terms/PolicyLegalTerms")
);
const AboutUs = lazyWithReload(() => import("pages/about-us/AboutUs"));
const PageNotFound = lazyWithReload(() =>
  import("../pages/static/PageNotFound")
);
const SpecialNeeds = lazyWithReload(() => import("pages/static/SpecialNeeds"));
const VirtualTour = lazyWithReload(() =>
  import("pages/virtual-tour/VirtualTour")
);
const RedirectingToCambridge = lazyWithReload(() =>
  import("pages/static/RedirectingToCambridge")
);
// import City from "pages/city/City";
// import Home from "pages/home/Home";
// import Property from "pages/property/Property";
// import Agents from "pages/static/Agents";
// import BlogListing from "pages/static/BlogListing";
// import ContactUs from "pages/static/ContactUs";
// import DowningRebook from "pages/static/DowningRebook";
// import Faqs from "pages/static/Faqs";
// import Friend from "pages/static/Friend";
// import GroupBooking from "pages/static/GroupBooking";
// import Offers from "pages/static/Offers";
// import Parent from "pages/static/Parent";
// import RoomType from "pages/room-type/RoomType";
// import SquareGardens from "pages/static/SquareGardens";
// import StudentLifeAtDowning from "pages/static/StudentLifeAtDowning";
// import Support from "pages/static/Support";
// import CityListing from "pages/static/CityListing";
// import FindYourRoom from "pages/static/FindYourRoom";
// import Compare from "pages/comparison/ComparionPage";
// import ViewwingDetail from "pages/viewing-detail/ViewingDetail";
// import BookAViewing from "pages/book-a-viewing";
// import SummerStay from "pages/summerstayspage/SummerStay";
// import PolicyLegal from "pages/legal/PolicyLegal";
// import Favourite from "pages/favourites/Favourite";
// import UniverSitypage from "pages/university/UniverSitypage";
// import Wellness from "pages/wellness/Wellnes";
// import BlogDetailPage from "pages/static/BlogDetail";
// import PolicyLegalCookie from "pages/legal-cookie/PolicyLegalCookie";
// import PolicyLegalTerms from "pages/legal-terms/PolicyLegalTerms";
// import AboutUs from "pages/about-us/AboutUs";
// import PageNotFound from "../pages/static/PageNotFound";
// import SpecialNeeds from "pages/static/SpecialNeeds";

export const authRoutes = [
  // {
  //   path: "/",
  //   component: <Navigate to="/" replace />,
  //   title: "Home",
  // },
  {
    path: "/",
    component: <City />,
    title: "City",
  },
  {
    path: "/manchester/square-gardens",
    component: <SquareGardens />,
    title: "Square Gardens",
  },
  {
    path: "/:cityId/:propertyId",
    component: <Property />,
    title: "Property",
  },
  {
    path: "/student-life-at-the-railyard",
    component: <StudentLifeAtDowning />,
    title: "Student life at The Railyard",
  },
  {
    path: "/about-us",
    component: <AboutUs />,
    title: "About us",
  },
  {
    path: "/parent",
    component: <Parent />,
    title: "Parent",
  },
  {
    path: "/agent",
    component: <Agents />,
    title: "Agents",
  },
  {
    path: "/friend",
    component: <Friend />,
    title: "Friend",
  },
  // {
  //   path: "/the-railyard-rebook",
  //   component: <DowningRebook />,
  //   title: "The Railyard Rebook",
  // },
  {
    path: "/support",
    component: <Support />,
    title: "Support",
  },
  // {
  //   path: "/group-booking",
  //   component: <GroupBooking />,
  //   title: "Group Booking",
  // },
  {
    path: "/contact-us",
    component: <ContactUs />,
    title: "Contact Us",
  },
  {
    path: "/offers",
    component: <Offers />,
    title: "Offers",
  },
  {
    path: "/faqs",
    component: <Faqs />,
    title: "Faqs",
  },
  {
    path: "/blog-listing",
    component: <BlogListing />,
    title: "Blog Listing",
  },
  {
    path: "/blog/:slug",
    component: <BlogDetailPage />,
    title: "Blog Detail",
  },
  {
    path: "/compare",
    component: <Compare />,
    title: "Compare",
  },
  {
    path: "/:cityId/:propertyId/:roomId",
    component: <RoomType />,
    title: "Room Type",
  },

  {
    path: "/city-listing",
    component: <CityListing />,
    title: "City Listing",
  },
  {
    path: "/find-your-room/:step",
    component: <FindYourRoom />,
    title: "Find Your Room",
  },
  {
    path: "/viewing-detail",
    component: <ViewwingDetail />,
    title: "Viewing detail",
  },
  {
    path: "/book-a-viewing/:propertySlug",
    component: <BookAViewing />,
    title: "Book a Viewing",
  },
  {
    path: "/privacy-policy",
    component: <PolicyLegal />,
    title: "Legal",
  },
  {
    path: "/cookie-policy",
    component: <PolicyLegalCookie />,
    title: "Legal",
  },
  {
    path: "/terms-and-conditions",
    component: <PolicyLegalTerms />,
    title: "Legal",
  },
  {
    path: "/favourite",
    component: <Favourite />,
    title: "Favourite",
  },
  {
    path: "/university",
    component: <UniverSitypage />,
    title: "University",
  },
  {
    path: "/wellness-welfare",
    component: <Wellness />,
    title: "Wellness Welfare",
  },
  {
    path: "/special-needs",
    component: <SpecialNeeds />,
    title: "Special Needs",
  },
  {
    path: "/virtual-tour",
    component: <VirtualTour />,
    title: "Virtual Tour",
  },
  {
    path: "/redirect-to-login",
    component: <RedirectingToLogin />,
    title: "Redirect to Login",
  },
  {
    path: "/redirect-to-booking",
    component: <RedirectToBooking />,
    title: "Redirect to Booking",
  },
  { path: "/404", component: <PageNotFound />, title: "404 (preview)" },
  { path: "*", component: <PageNotFound />, title: "Not Found" },
];

export const protectedRoutes = [];
